// AssignmentListSection.tsx
import * as React from "react";
import AssignmentList from "./AssignmentList";
import { AssignmentListSectionProps } from "@/lib/AssignmentSectinProps";

export default function AssignmentListSection({
  form,
  allBatch,
  assignments,
  toggleExpanded,
  expandedItems,
  handleChange,
  handleEdit,
  handleDelete,
}: AssignmentListSectionProps) {

  return (
    <>
      {/* Filters */}
      <div className="flex space-x-5 mb-4">
        <div className="space-y-2">
          <select
            name="batch"
            className="border rounded-md px-2 py-2 bg-background"
            value={form.batch}
            onChange={handleChange}
          >
            <option value="">Select Batch</option>
            {allBatch?.map((b: Batch) => (
              <option key={b._id} value={b._id}>
                {b.bCode}
              </option>
            ))}
          </select>
        </div>

        <div className="space-y-2">
          <select
            name="type"
            className="border rounded-md px-2 py-2 bg-background"
            value={form.type}
            onChange={handleChange}
          >
            <option value="assignment">Assignment</option>
            <option value="task">Task</option>
          </select>
        </div>
      </div>
      {/* Assignment List */}
      {assignments?.length === 0 ? (
        <p>No assignments yet.</p>
      ) : (
        <AssignmentList
          assignments={assignments?.map((a) => ({
            ...a,
            isExpanded: expandedItems[a._id],
          }))}
          onToggleExpand={toggleExpanded}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      )}
    </>
  );
}
